import { contentUpdate } from '~/app/store/content'
import { addDefaultsToRefinements } from '~/app/store/refinement/refinementTranslation'
import { LOCATION_POP } from '~/app/store/constants'

export const stateFromQueryStateUpdate =
  (queryState: Gallery.Models.Url.QueryStringState, prevQueryString: Gallery.Models.Url.QueryStringState) =>
  (dispatch: State.GalleryThunkDispatch, getState: () => State.GlobalState): void => {
    const state = getState()

    if (queryState.query.qv !== prevQueryString.query.qv) {
      dispatch({
        type: LOCATION_POP,
        payload: {
          ...queryState,
          showSpinner: false,
        },
      })

      return
    }

    dispatch(
      contentUpdate({
        actions: {
          type: LOCATION_POP,
          payload: {
            ...queryState,
            refinements: {
              ...queryState.refinements,
              attributes: addDefaultsToRefinements(queryState.refinements.attributes, state),
            },
            showSpinner: true,
          },
        },
        shouldUpdateUrl: false,
      }),
    )
  }
